import { ActionButton, Modal } from "components/commons";
import locale from "localization";
import styles from "./confirm-cancel-voucher-modal.module.scss";
import React, { useCallback } from "react";

const ConfirmCancelVoucherModal = ({ onSubmitCancel, loading, name, ...modalState }) => {
  const { close, active } = modalState;

  const submit = useCallback(() => {
    return onSubmitCancel();
  }, [onSubmitCancel]);

  return (
    <Modal
      active={active}
      title={`${locale.cancelCampaign}?`}
      close={close}
      className={styles.modal}
      titleStyle={styles.title}
      contentStyle={styles.contentBody}
    >
      <div className={styles.content}>
        <locale.Populate
          text={locale.youAreAboutToCancelCampaign}
          items={[<strong>{name}</strong>, name]}
        />
      </div>
      <ActionButton
        right
        items={[
          {
            onClick: () => {
              close();
            },
            text: locale.cancel,
          },
          {
            onClick: () => {
              submit();
            },
            text: locale.yesCancelIt,
            loading: loading,
          },
        ]}
      />
    </Modal>
  );
};

export default ConfirmCancelVoucherModal;
